import React from 'react';
import "./news.css"
import NewsPic from "../news-pic/PHOTO-2024-12-14-00-02-15.jpg"

const News1 = () => {
    return (
        <div>
            <br/>
            <br/>
            <br/>
            <div class="news">
                <article class="news-item">
                    <div class="news-item__date">
                        <svg class="news-item__date-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#718096" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        24 декабря 2024
                    </div>

                    <h2 class="news-item__title">Расширение экономических возможностей женщин в Центральной Азии: Заседание региональной рабочей группы в Стамбуле</h2>

                    <div class="news-item__content">
                        <p>C 12-13 декабря 2024 года, в Стамбуле Турция проходило очередное
                            Заседание Центральноазиатской Региональной Рабочей Группы по
                            расширению экономических возможностей женщин, членом которой
                            является Салимова Лола Джумаевна Заместитель Председателя Ассоциации
                            Банков Таджикистана. Организаторами данного мероприятия является
                            Программа развития коммерческого права (СDLP) в координации с
                            Торговым представителем США. В повестке заседания были рассмотрены
                            вопросы связанные с состоянием экономической статистики с разбивкой по
                            полу в Центральной Азии. Были представлены передовой опыт в области
                            измерения женского труда и критерии определения женского
                            предпринимательства.
                            Также были рассмотрены дальнейшие шаги по использованию
                            дезагрегированных данных по признаку пола для расширения экономических
                            прав и возможностей женщин</p>
                    </div>

                    <div class="news-item__gallery">
                        
                        <div class="news-item__image">
                            <img src={NewsPic} alt="Фото с заседания 1" />
                        </div>
                        <div class="news-item__image">
                            <img src={NewsPic} alt="Фото с заседания 2" />
                        </div>
                        <div class="news-item__image">
                            <img src={NewsPic} alt="Фото с заседания 3" />
                        </div>
                        <div class="news-item__image">
                            <img src={NewsPic} alt="Фото с заседания 4" />
                        </div>
                    </div>
                </article>
            </div>
        </div>
    );
}

export default News1;
